import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { OfferResponse } from '../types'

export const useOffer = (offerId?: number) => {
  return useQuery({
    queryKey: ['offer', offerId],
    queryFn: ({ signal }) =>
      fetchApiWithToken<OfferResponse>({
        method: 'get',
        url: `/v1/offers/${offerId}`,
        signal
      }),
    enabled: !!offerId
  })
}
